import type { RouteRecordRaw } from 'vue-router';
import { createMemoryHistory, createRouter, createWebHistory } from 'vue-router';
import Checkout from '@/checkout/Checkout.vue';
import Payment from './Payment.vue';
import CheckoutConfirmation from './CheckoutConfirmation.vue';
import CheckoutFinalizeScreen from './CheckoutFinalizeScreen.vue';

import { useRootStore } from '@/stores/root';

const routes: RouteRecordRaw[] = [
  {
    path: '/e/:eventId',
    name: 'OrderNew',
    component: Checkout,
  },
  {
    path: '/e/:eventId/checkout',
    name: 'OrderPayment',
    component: Payment,
  },
  {
    path: '/e/:eventId/finalize',
    name: 'OrderFinalize',
    component: CheckoutFinalizeScreen,
  },
  {
    path: '/confirmation/:fingerprint',
    name: 'OrderConfirmation',
    component: CheckoutConfirmation,
  },
  // {
  //   path: '/events/:eventId/orders/confirmation/:fingerprint/tickets',
  //   name: 'OrderTickets',
  //   component: OrderDetails,
  // },
];

const router = createRouter({
  history: (() => (import.meta.env.SSR ? createMemoryHistory() : createWebHistory()))(),
  routes,
});

router.afterEach(to => {
  const rootStore = useRootStore();
  rootStore.SET_CURRENT_ROUTE(to);
});

export default router;
